import { Component, computed, effect, ElementRef, HostListener, Inject, input, output, signal, viewChild } from '@angular/core';
import { AnalogIn, AnalogOut, Assignement, DigitalIn, DigitalOut, IOBaseType, IOType, RangedKanaal, RangedKanaalAssign, RangedKanaalInput } from '../../props/PropTypes';
import { JSBridgeService } from '../../core/jsbridge.service';
import { KanaalService } from '../../kanaal/kanaal.service';
import { KanaalSelection } from '../kanaal-selector/KanaalSelectorBase';
import { HwdConfigService } from '../hwd-config.service';
import { buildKanaalMap, getAssignment, getAvailableRanges, getNextAvailableKanaal } from '../kanaal.utils';
import { arrowRotateCcwIcon } from "@progress/kendo-svg-icons";
import { DialogService } from '@progress/kendo-angular-dialog';
import { TranslateService } from '../../i18n/translate.service';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'kanaal-input',
  templateUrl: './kanaal-input.component.html',
   host: {
    tabindex: '0'
  },
  styleUrl: './kanaal-input.component.scss'
})
export class KanaalInputComponent {

  public arrowRotateCcwIcon = arrowRotateCcwIcon;

  constructor(public jsBridgeService: JSBridgeService, public kanaalService: KanaalService,
    public hdwConfigService: HwdConfigService, private dialogService: DialogService, private translateService: TranslateService,
    @Inject('i18n-label') private i18nLabel: any, private elementRef: ElementRef<HTMLElement>) {
    effect(() => {
      let initValue = this.initialValue();
      let vAI = this.virtualAI();
      this.ioType = initValue.ioType;
      this.range = initValue.range;
      this.inverted = initValue.inverted == true;
      this.volt = initValue.volt == true;
      let start = this.getDefaultStart(initValue.start);
      if (AnalogIn.equals(this.ioType) || vAI) {
        this.start = start >> 1;
        if (vAI) {
          this.isA = false;
          start = this.start << 2;
        } else {
          this.isA = (start & 1) == 1;
        }
      } else {
        this.start = start;
      }
      this.kanaalSelection = {
        kanaal: {
          start: start,
          ioType: initValue.ioType,
          range: initValue.range
        },
      };
      if (start != initValue.start) {
        this._onKanaalChange(this.start);
      }

    });

  }

  public textBox = viewChild<NumericTextBoxComponent>("kanaalTextBox");

  public ngOnDestroy() {
    let assign = this.assignement();
    if (assign) {
      this.hdwConfigService.unregisterTempKanaal(assign.key);
    }
  }

  private touched: boolean = false;


  private getDefaultStart(v: number) {
    if (v > 0) {
      return v;
    }
    if (!this.autofilKanaal() || this.touched) {
      return 0;
    }

    let nextStart = this.hdwConfigService.getNextStart(this.ioType, this.virtualAI(), this.range, this.maxKanaal());
    this.autoFillOutOfRange = nextStart.outOfRange;
    return nextStart.start;
  }

  public async onAutoFill() {
    if (this.kanaalSelection.kanaal != undefined && this.kanaalSelection.kanaal.start != 0) {
      return;
    }
    let nextStart = this.hdwConfigService.getNextStart(this.ioType, this.virtualAI(), this.range, this.maxKanaal());
    let start = nextStart.start;
    this.autoFillOutOfRange = nextStart.outOfRange;
    if (AnalogIn.equals(this.ioType) || this.virtualAI()) {
      this.isA = (start & 1) == 1;
      start = start >> 1;

    }
    if (this.autoFillOutOfRange) {
      this.dialogService.open({
        title: await this.translateService.getTranslation(this.i18nLabel, "Error", "Error"),
        content: await this.translateService.getTranslation(this.i18nLabel, "Onvoldoende beschikbare kanalen aan het einde. Kies handmatig!", "Onvoldoende beschikbare kanalen aan het einde. Kies handmatig!"),
        actions: [{ text: "Close", themeColor: "primary" }],
      });

    }
    this.onKanaalChange(start);
  }

  public initialValue = input.required<RangedKanaalInput>();
  public showTypeLabel = input<boolean>(false);
  public autoFillOutOfRange = false;
  // public key = input<string>("default");

  public assignement = input<Assignement>();

  public assign = computed(() => {
    let kfg = this.jsBridgeService.getBridgeSync().getConfig();
    let assignement = this.kanaalService.getKonfigKanalen(kfg);
    return assignement;
  });



  public valueChanged = output<RangedKanaalInput>();
  public isA: boolean = false;
  public start: number = 0;
  public range: number = 1;
  public inverted: boolean = false;
  public volt: boolean = false;
  public ioType: IOType = AnalogIn;

  public showSelector: boolean = false;


  public virtualAI = input<boolean>(false);
  public showCheckboxes = input<boolean>(true);
  public showLabel = input<boolean>(true);
  public autofilKanaal = input<boolean>(true);
  public maxKanaal = input<number>(65536);


  hasAKanaal = computed(() => {
    if (this.virtualAI()) {
      return true;
    }
    return (AnalogIn.equals(this.initialValue().ioType)) && (this.initialValue().range == 1);
  });

  hasInverted = computed(() => {
    return DigitalIn.equals(this.initialValue().ioType) || DigitalOut.equals(this.initialValue().ioType) || AnalogOut.equals(this.initialValue().ioType);
  });

  hasVolt = computed(() => {
    return (AnalogOut.equals(this.initialValue().ioType));
  });

  canChoose = computed(() => {
    let ioType = this.initialValue().ioType;
    if ((ioType.type == IOBaseType.MQTT) || (ioType.type == IOBaseType.ModBus)) {
      return false;
    }
    return true;
  })

  public kanaalMap = computed(() => {

    return buildKanaalMap(this.assign());
  });

  validateKanaal(playSound: boolean = false) {
    let input: KanaalSelection = this.kanaalSelection;
    if (input != undefined && input.kanaal != undefined) {
      let kanaalMap = this.kanaalMap();
      for (let k = 0; k < input.kanaal.range; k++) {
        let kanaal = input.kanaal.start + k;
        let assig = getAssignment(input.kanaal.ioType, kanaal, kanaalMap);
        if (assig.length > 0) {
          if (playSound) {
            var audio = new Audio('/assets/beep-07a.mp3');
            audio.play();
          }
          return false;
        }
      }
    }
    return true;
  }

  _onKanaalChange(kanaal: number) {
    let vAI = this.virtualAI();
    this.start = kanaal;
    let ret = this.toOutput();

    if (AnalogIn.equals(this.ioType) || vAI) {
      ret.start = this.start * 2 + (this.isA ? 1 : 0);
    } else {
      ret.start = this.start;
    }
    this.kanaalSelection.kanaal = ret;
    this.isValid = this.validateKanaal();
    this._onValueChanged(ret);
  }

  onKanaalChange(kanaal: number) {
    this._onKanaalChange(kanaal);
    this.touched = true;
  }

  onAKanaalChange(isA: boolean | string) {
    this.isA = isA ? true : false;
    let ret = this.toOutput();
    ret.start = this.start * 2 + (this.isA ? 1 : 0);
    this.kanaalSelection.kanaal = ret;
    this.isValid = this.validateKanaal();
    this._onValueChanged(ret);
  }

  onShowSelector() {
    this.showSelector = !this.showSelector;
  }

  private toOutput(): RangedKanaalInput {
    let ret: RangedKanaalInput = {
      ioType: this.ioType,
      range: this.range,
      start: this.start,
      inverted: this.inverted,
      volt: this.volt
    };
    return ret;
  }

  onInvertedChange(inverted: boolean | string) {
    this.inverted = inverted ? true : false;
    let ret = this.toOutput();
    this._onValueChanged(ret);
  }

  onVoltChanged(volt: boolean | string) {
    this.volt = volt ? true : false;
    let ret = this.toOutput();
    this._onValueChanged(ret);
  }

  public kanaalSelection: KanaalSelection = {}
  public ks = signal<KanaalSelection>({});
  public isValid: boolean = true;

  onKanaalSelected(e: KanaalSelection) {
    if (e.kanaal == undefined) {
      return;
    }
    if (e.kanaal.start + e.kanaal.range > this.maxKanaal()) {
      return;
    }
    this.kanaalSelection = e;
    this.isValid = this.validateKanaal();
    this.touched = true;
  }

  onOK() {
    if (this.kanaalSelection.kanaal != undefined) {
      let ret = this.toOutput();
      ret.start = this.kanaalSelection.kanaal.start;
      this._onValueChanged(ret);
    }
    this.showSelector = false;
  }

  _onValueChanged(value: RangedKanaalInput) {
    let assign = this.assignement();
    if (assign) {
      this.hdwConfigService.registerTempKanaal(assign.key, {
        assignement: assign,
        rangedKnaal: value
      });
    }
    this.valueChanged.emit(value);
  }

}
